import React from 'react'
import AioText from "./AioText"
import css from './aio.less'

interface AioNumberProps extends React.ComponentProps<typeof AioText> {
    currency?: string
}

export default function AioNumber({className,currency,...props}: AioNumberProps) {
    return <AioText className={[css.dollar,className]} inputMode="decimal" min="-1000000000" step="0.01" max="1000000000" {...props}/>
}
